import React, { useCallback, useContext } from 'react';
import { useWorkspace } from './WorkspaceContext';
import { useApi } from './ApiContext';

const MemberContext = React.createContext();

function MemberProvider({ children }) {
  const { workspace, updateMember } = useWorkspace();
  const api = useApi();

  const refresh = useCallback(async () => {
    if (!workspace?.id) {
      return;
    }
    const { data } = await api.www.workspaces(workspace.id).members().current();
    updateMember(data);
  }, [api, workspace?.id, updateMember]);

  const isCurrent = useCallback((member) => workspace?.member?.id === member?.id, [workspace?.member?.id]);

  return (
    <MemberContext.Provider value={{ member: workspace?.member ?? null, updateMember, refresh, isCurrent }}>
      {children}
    </MemberContext.Provider>
  );
}

function useMember() {
  return useContext(MemberContext);
}

export { MemberContext, MemberProvider, useMember };
